import {
  StepProps,
  FlowAction,
  FunnelState,
  FormAnswer,
} from 'scenes/common/flows/types';
import { ApiData } from 'scenes/common/helpers/apiData/types';

import { MotorQuoteDetails } from 'scenes/motor/flows/coverOptions/types';
import { HomeQuoteDetails } from 'scenes/home/flows/coverOptions/types';
import { LandlordQuoteDetails } from 'scenes/landlord/flows/coverOptions/types';
import { Config } from 'scenes/common/types/config';

export enum RetrieveFlowType {
  RetrieveQuoteDetails = 'retrieveQuoteDetails',
}

export enum RetrieveStepType {
  RetrieveQuote = '',
}

// not sure if we need to store any values from retrieve flow
type RetrieveFormState = {};

export type RetrieveFormValues = RetrieveFormState;

export type RetrieveFlowAction = FlowAction<
  RetrieveFormValues,
  RetrieveStepType
>;
export type RetrieveFormAnswer = FormAnswer<
  RetrieveFormValues,
  RetrieveStepType
>;

export interface RetrieveApiResponse {
  motorQuoteDetails: ApiData<MotorQuoteDetails>;
  homeQuoteDetails: ApiData<HomeQuoteDetails>;
  landlordQuoteDetails: ApiData<LandlordQuoteDetails>;
  config: ApiData<Config>;
}

export type RetrieveFunnelState = FunnelState<
  RetrieveFlowType,
  RetrieveStepType
> & {
  apiResponses: RetrieveApiResponse;
};

export enum RetrieveQueryParamKeys {
  QuoteNumber = 'QuoteID',
}

export enum QuoteNumberPrefixes {
  COMO = 'COMO',
  COHO = 'COHO',
  COLA = 'COLA',
}

export type RetrieveStepProps = StepProps<
  RetrieveFlowType,
  RetrieveStepType,
  RetrieveFunnelState
> & {
  defaultQuoteNumber: string | null;
  onRetrieveQuote: (quoteNumber: string, postcode: string, dob: string) => void;
};
